import {BasePanel} from "./BasePanel";

export class CustomPanel extends BasePanel {
    renderDefault() {
        return null;
    }
}
